export const chartColors = {
  blue: 'hsl(var(--chart-1))',
  green: 'hsl(var(--chart-2))',
  red: 'hsl(var(--chart-3))',
  purple: 'hsl(var(--chart-4))',
  orange: 'hsl(var(--chart-5))',
  teal: 'hsl(var(--chart-6))',
  pink: 'hsl(var(--chart-7))',
  yellow: 'hsl(var(--chart-8))',
  violet: 'hsl(var(--chart-9))',
  cyan: 'hsl(var(--chart-10))',
  sky: 'hsl(var(--chart-11))',
  lime: 'hsl(var(--chart-12))',
  rose: 'hsl(var(--chart-13))',
  lightBlue: 'hsl(var(--chart-14))',
  brand: 'hsl(var(--chart-15))',
  gray: 'hsl(var(--chart-16))',
}

export const chartPalette = Object.values(chartColors)

export const semanticColors = {
  income: chartColors.green,
  expense: chartColors.red,
  inflow: chartColors.green,
  outflow: chartColors.red,
  primary: chartColors.blue,
}

export const AMOUNT_TONE = {
  positive: 'text-emerald-500',
  negative: 'text-red-600',
} as const

export const amountTone = (amount: number) =>
  amount < 0 ? AMOUNT_TONE.negative : AMOUNT_TONE.positive

export const categoryColors = {
  'Bank fees': chartColors.blue,
  Entertainment: chartColors.red,
  'Food and drink': chartColors.purple,
  'General merchandise': chartColors.yellow,
  'General services': chartColors.pink,
  'Government and non profit': chartColors.sky,
  'Home improvement': chartColors.lime,
  Income: chartColors.green,
  'Loan payments': chartColors.orange,
  Medical: chartColors.rose,
  'Personal care': chartColors.teal,
  'Rent and utilities': chartColors.violet,
  'Transfer in': chartColors.lightBlue,
  'Transfer out': chartColors.cyan,
  Transportation: chartColors.gray,
  Travel: chartColors.brand,
}

export const projectStatusColors = {
  SUCCEEDED: chartColors.green,
  PROCESSING: chartColors.blue,
  FAILED: chartColors.red,
  NOT_STARTED: chartColors.gray,
}
